import { PdfHighlighter, PdfLoader } from 'react-pdf-highlighter';
// import "react-pdf-highlighter/dist/style.css";



const PdfPreviewer = ({ url}) => {

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <PdfLoader
        url={url}
        workerSrc="/pdfjs-dist/pdf.worker.min.js"
        onError={(e) => {
          console.warn(e);
        }}
        

      >
        {(pdfDocument) => {
          return (
            <PdfHighlighter
              pdfDocument={pdfDocument}
              enableAreaSelection={(event) => event.altKey}
              scrollRef={() => {}}
              onSelectionFinished={() => null}
              highlights={[]}
            />
          );
        }}
      </PdfLoader>
    </div>
  );
};

export default PdfPreviewer;